import {Injectable} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {Subject} from 'rxjs/Subject';
import {Alert, AlertType} from '../model/alert';
import 'rxjs/add/operator/filter';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../environments/environment";

@Injectable()
export class EnvService {

  instance: any;

  constructor(private translate: TranslateService) {
    this.instance = environment.lang[translate.currentLang] || {};
    translate.onLangChange.subscribe(() => {
      this.instance = environment.lang[translate.currentLang] || {};
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/service/env.service.ts